import { callExternalApi, CallResult } from '../callExternalApi';

// Narrower than the portal's AiSummary: no contextLabel, and id is nulled once retention prunes the narrative.
export interface ReportAiSummary {
  id: string | null;
  summaryText: string;
  generatedAt: string;
}

export interface ReportSnapshot {
  id: string;
  schedule_setting_id: string;
  content: Record<string, unknown>[];
  created_at: string;
  updated_at: string;
  ai_summary: ReportAiSummary | null;
}

export interface ReportViewConfig {
  muiConfig: {
    pinnedColumns?: Record<string, string[]>;
    columns?: {
      columnVisibilityModel?: Record<string, boolean>;
      orderedFields?: string[];
      dimensions?: Record<string, unknown>;
    };
    sorting?: {
      sortModel?: Array<{ field: string; sort: string }>;
    };
    pagination?: {
      paginationModel?: { page: number; pageSize: number };
    };
    filter?: Record<string, unknown>;
    density?: string;
    preferencePanel?: Record<string, unknown>;
  };
  customView?: boolean;
  disabledFields?: string[];
}

export interface ReportTab {
  tab_name: string;
  table_type: string;
  view_config: ReportViewConfig | null;
  position: number;
  content?: Record<string, unknown>[];
}

export interface ReportResponse {
  snapshot: ReportSnapshot;
  view_config: ReportViewConfig | null;
  view_type?: 'project' | 'asset' | 'inventory' | 'case' | 'related_project_assets' | 'order';
  view_name?: string;
  tabs?: ReportTab[];
}

export interface CopyConfigResponse {
  message: string;
}

export async function fetchReport(
  scheduleSettingId: string,
  scheduleSnapshotId: string,
  authToken: string
): Promise<CallResult<ReportResponse>> {
  return callExternalApi<ReportResponse>(
    {
      url: 'api/report',
      method: 'GET',
      params: {
        schedule_setting_id: scheduleSettingId,
        schedule_snapshot_id: scheduleSnapshotId,
        auth_token: authToken
      },
      headers: { Accept: 'application/json' }
    },
    true
  );
}

export async function postCopyConfig(
  scheduleSettingId: string,
  copyToken: string,
  portalUserId: string
): Promise<CallResult<CopyConfigResponse>> {
  return callExternalApi<CopyConfigResponse>(
    {
      url: 'api/report/copy_config',
      method: 'POST',
      params: {
        schedule_setting_id: scheduleSettingId,
        copy_token: copyToken,
        portal_user_id: portalUserId
      },
      headers: { Accept: 'application/json' }
    },
    true
  );
}
